import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ConnectionService } from '../../service/connection.service';

@Component({
  selector: 'app-team-attiva',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './team-attiva.component.html',
  styleUrl: './team-attiva.component.css',
})
export class TeamAttivaComponent implements OnInit {
  token = '';
  password = '';
  confirm = '';
  loading = false;
  done = false;
  error = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private connection: ConnectionService,
  ) {}

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('token') ?? '';
    if (!this.token) {
      this.router.navigate(['/login']);
    }
  }

  submit() {
    this.error = '';
    if (!this.password || this.password.length < 8) {
      this.error = 'La password deve avere almeno 8 caratteri.';
      return;
    }
    if (this.password !== this.confirm) {
      this.error = 'Le due password non coincidono.';
      return;
    }
    this.loading = true;
    this.connection.post(
      '@auth/team/activate',
      { token: this.token, password: this.password },
      () => {
        this.loading = false;
        this.done = true;
        setTimeout(() => this.router.navigate(['/login']), 3000);
      },
      (err: any) => {
        this.loading = false;
        this.error = err?.error?.message ?? 'Link non valido o scaduto.';
      },
    );
  }
}
